import { render, staticRenderFns } from "./Fraude.vue?vue&type=template&id=5116e38c&scoped=true"
import script from "./Fraude.vue?vue&type=script&lang=js"
export * from "./Fraude.vue?vue&type=script&lang=js"
import style0 from "./Fraude.vue?vue&type=style&index=0&id=5116e38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5116e38c",
  null
  
)

export default component.exports